<template>
    <div>
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
            <div style="font-size: 15px;">
                <span class="fw-500" style="text-transform:capitalize;">
                    <span v-if="$route.path == '/pm/ticketdetails'">
                        PM
                    </span>
                    Review Ticket </span>  |  {{ total }} Total
            </div>
            <div class="d-flex align-items-center mt-1">
                <button class="btn btn-success btn-smm ml-2" style="color:#fff !important;" @click="createTickets()" >
                    <i class="icon icon-plus-circle text-white fs-16" style="color:#fff !important;position: relative; top:-1px;"></i>
                    <span class="text-white ml-1 hidden-sm-down fs-13">Create New Ticket</span>
                </button>
            </div>
        </div>
        <div class="table-content mb-3" style="overflow-x: auto !important;">
            <table class="table table-content-data table-responsive">
                <thead>
                    <tr>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('ticket_number')" class="cursor-th" >
                                Ticket ID
                                <span v-if="passed_key.key=='ticket_number' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'ticket_number'}" class="sorting-icon">
                                    <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'ticket_number'}" class="sorting-icon">
                                    <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('ticket_number')" class="cursor-th" >
                                Ticket Creator
                                <span v-if="passed_key.key=='ticket_number' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'ticket_number'}" class="sorting-icon">
                                    <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'ticket_number'}" class="sorting-icon">
                                    <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('subject')" class="cursor-th" >
                                Subject
                                <span v-if="passed_key.key=='subject' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'subject'}" class="sorting-icon">
                                    <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'subject'}" class="sorting-icon">
                                    <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('created_date')" class="cursor-th" >
                                Date Created
                                <span v-if="passed_key.key=='created_date' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                    <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                    <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('assigned_to')" class="cursor-th" >
                                Part Name
                                <span v-if="passed_key.key=='assigned_to' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'assigned_to'}" class="sorting-icon">
                                    <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'assigned_to'}" class="sorting-icon">
                                    <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                </span>
                            </span>
                        </th>
                        <th class="whiteSpace w-1 mw-200px">
                            <span v-on:click="setPasskey('status')" class="cursor-th" >
                                Review Status
                                <span v-if="passed_key.key=='status' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'status'}" class="sorting-icon">
                                    <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                </span>
                                <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'status'}" class="sorting-icon">
                                    <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                </span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="ajax_loader" class="text-center font-weight-bold" style="background-color: #eff9fd !important;">
                        <td colspan="9">
                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                        </td>
                    </tr>
                    <tr v-else-if="!ajax_loader && ticket_list.length == 0" class="text-center font-weight-bold ht-100px">
                        <td colspan="9">No Tickets Found</td>
                    </tr>
                    <tr v-else v-for="ticket in ticket_list" :key="ticket.ticket_id">
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            <span class="pointer text-secondary">{{"#" +ticket.ticket_number}}</span>
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            {{ticket.created_by || '-'}}
                        </td>
                        <td class="whiteSpace w-1 pointer text-capitalize" @click="ticketDetails(ticket)">
                            <span style="max-width:150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: inline-block;">{{ticket.subject || '-'}}</span>
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            {{ticket.created_date}}
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            {{ticket.template_part_name || '-'}}
                        </td>
                        <td class="whiteSpace w-1 pointer" @click="ticketDetails(ticket)">
                            <button style="text-transform: capitalize; width: 110px !important;" class="btn btn-smm text-white btn-default btn-width btn-success-border-radius"  
                            :class="{'btn-open-status-newtheme':ticket.part_review_status == 'Open',
                            'btn-assigned':ticket.part_review_status == 'Assigned',
                            'btn-review':ticket.part_review_status == 'Review',
                            'btn-unassign':ticket.part_review_status == 'Unassigned',
                            'btn-grid-inprogress-newtheme':ticket.part_review_status == 'In progress',
                            'btn-fixed-newtheme':ticket.part_review_status == 'Fixed',
                            'btn-closed-newtheme':ticket.part_review_status == 'Closed', 
                            'btn-reopen-newtheme':ticket.part_review_status == 'Re-Open',
                            'btn-rejected':ticket.part_review_status == 'Reject', 
                            'btn-schedule':ticket.part_review_status == 'Scheduled',
                            'btn-approved':ticket.part_review_status == 'Approved',
                            'rejected-btn':ticket.part_review_status == 'Rejected'}">
                                {{ticket.part_review_status}}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end">
            <button class="mt-1 pointer pagination-list" @click="firstPage()" :disabled="skip == 0">
                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                    <i class="icon-chevron-double-left"></i>
                </el-tooltip>
            </button>
            <button class="pagination-list mt-1 ml-2 pointer" @click="previousPage()" :disabled="skip == 0">
                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                    <i class="icon icon-chevron-left"></i>
                </el-tooltip>
            </button>
            <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
            <button class="pagination-list mt-1 mr-2 pointer" @click="nextPage()" :disabled="skip_temp >= total">
                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                    <i class="icon icon-chevron-right"></i>
                </el-tooltip>
            </button>
            <button @click="lastPage()" :disabled ="temp_total == total" class="mt-1 pointer pagination-list">
                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                    <i class="icon-chevron-double-right"></i>
                </el-tooltip>
            </button>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import ticket from '../mixins/ticket.js';
import Swal from 'sweetalert2';
import {SweetModal} from 'sweet-modal-vue';
import { EventBus } from '../eventBus/nav-bar-event.js';
export default{
    mixins: [ticket],
    data(){
        return {
            ajax_loader: false,
            ticket_list: [],
            passed_key:{
                key: '',
                value: ''
            },
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            skip_temp: 0,
        }
    },
    methods: {
        ticketDetails(ticket){
            this.$router.push({
                path: `/ticketdetails/view/${ticket.ticket_id}`,
                query: {
                    type: 'review_ticket',
                    part_name: ticket.template_part_name,
                    part_status: ticket.part_review_status
                }
            })
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            this.ticket_list = []
            this.getReviewTicketAPI()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getReviewTicketAPI();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            this.temp_total = this.skip_temp
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getReviewTicketAPI();
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getReviewTicketAPI();
        },
        async getReviewTicketAPI(){
            try{
                this.ajax_loader = true
                let params = {
                    "limit": this.limit == "" || this.limit == 0 || this
                        .limit < 0 ? 10 : this.limit,
                    "skip": this.skip,
                    "sort_value": -1
                }
                let response = await this.ListTicketsToReview(params);
                this.ticket_list = response.response.all_tickets
                this.ticket_list.forEach((e) => {
                    if(e.part_review_status == 'Send For Approval' || e.part_review_status == 'Pending' || e.part_review_status == 'Sent For Approval'){
                        e.part_review_status = 'Review' 
                    }
                })
                this.total = response.response.total_no_of_tickets
                this.ajax_loader = false
            } catch(err) {
                this.ajax_loader = false
                console.log(err)
            }
        },
        createTickets() {
            let ticket ={
                ticket_id:'',
                ticket_number:''
            }
            localStorage.setItem("parentTicketDetails", JSON.stringify(ticket))
            this.$router.push({ name: "TicketsCreate" });
        },
        setPasskey(){

        }
    },
    computed:{
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    mounted(){
        this.getReviewTicketAPI()
    },
    created(){

    }
}
</script>

<style scoped>

</style>